// 问卷管理
export default [
  {
    path: "/question",
    name: "question",
    meta: { title: "问卷管理" },
    component: () => import("../views/question/index"),
    children: [
      {
        path: "/question/questionList",
        meta: { title: "问卷列表", isMenu: true },
        component: () => import("../views/question/questionList"),
      },
      {
        path: "/question/detail/apply",
        meta: { title: "创建问卷", isMenu: true },
        component: () => import("../views/question/detail/apply"),
      },
      {
        path: "/question/detail/questionDetail",
        meta: { title: "查看详情", isMenu: true },
        component: () => import("../views/question/detail/questionDetail"),
      },
    ],
  },
]
